exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-checkbox-group--horizontal {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n}", "", {"version":3,"sources":["D:/WenZhouBangZhang/BZQD/node_modules/vant/es/checkbox-group/D:/WenZhouBangZhang/BZQD/node_modules/vant/es/checkbox-group/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;CACjB","file":"index.css","sourcesContent":[".van-checkbox-group--horizontal {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./node_modules/px2rem-loader??ref--5-3!./node_modules/vant/es/checkbox-group/index.css
// module id = NwID
// module chunks = 170